import React, { useCallback } from 'react';
import { FormComponentBuilder } from 'components/common/form/layout';
import { type FormControlProps, type FormElementControlPropsType } from 'components/common/form/layout/control';
import KnowledgeGraphPanel from './KnowledgeGraphPanel/index';
import { getPkId } from '../form/formTools';
import { BackendNode } from './KnowledgeGraphPanel/types';
import { useMiNavigation } from 'hooks/useNavigation';

// ─── Props ─────────────────────────────────────────────────────────────────────

export interface KnowledgeGraphProps extends FormControlProps {
    dataUrl: string;
    currentNodeId?: number;
}

export default function KnowledgeGraph({ controlProps }: FormElementControlPropsType<KnowledgeGraphProps>) {
    const navigate = useMiNavigation();
    const { dataUrl, currentNodeId } = controlProps;

    const onNodeSelect = useCallback(
        (node: BackendNode | null) => {
            if (node != null && node.llm_learning_node_id !== currentNodeId) {
                navigate('/editor/graph/node/' + node.llm_learning_node_id + '#graph');
            }
        },
        [navigate, currentNodeId],
    );

    return <KnowledgeGraphPanel dataUrl={dataUrl} currentNodeId={currentNodeId} onNodeSelect={onNodeSelect} />;
}

export class KnowledgeGraphBuilder extends FormComponentBuilder {
    prepareProps(): KnowledgeGraphProps {
        const pkId = getPkId(this.elementProps.pk, this.elementProps.urlParams);
        return {
            ...this.controlProps,
            dataUrl: this.elementProps.componentProps?.dataUrl ?? '/data/editor/graph/node/graph-data',
            currentNodeId: pkId > '' ? parseInt(pkId) : undefined,
        };
    }
}
